import { formatDate } from 'redesign/shared/date'
import { DATE_FORMAT_VARIANTS } from 'redesign/shared/date/constants'
import { newDateWithoutTime } from 'utils/date'
import type { FormatAbsenceDateProps } from './types'

export const formatAbsenceDate = ({ date, t, locale }: FormatAbsenceDateProps) => {
  if (!date) return ''

  return formatDate({
    date: newDateWithoutTime(typeof date === 'string' ? date : date?.toISOString() ?? ''),
    dateFormat: DATE_FORMAT_VARIANTS.date,
    locale,
    t,
  })
}
